import { useEffect } from 'react'
import usePageContext from '../Page/context'

const useFooter = (footerRef: any) => {

  // Theme
  const {
    state: { theme, labelsData }, dispatch
  } = usePageContext()

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            dispatch({
              type: 'SET_THEME',
              payload: 'black'
            })
          }
        })
      },
      {
        root: null, // relative to the viewport
        rootMargin: '0px',
        threshold: 0.1 // trigger when at least 10% of the footer is visible
      }
    )

    if (footerRef.current) {
      observer.observe(footerRef.current)
    }

    return () => {
      if (footerRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(footerRef.current)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    theme,
    footerData: labelsData?.Footer || {}
  }
}

export default useFooter
